module.exports = __webpack_public_path__ + "static/media/frog(25).eb62f4cf.PNG";